import React from 'react';
import { Helmet } from 'react-helmet';
import { generateFAQSchema, generateWebSiteSchema } from './SchemaGenerator';

/**
 * GatePageSchema - Schema markup for the Gate Page (Homepage)
 * Includes Organization, WebSite, and FAQ schemas combined in @graph for stronger AIO indexing
 * Schema Strategy: Combined graph structure is stronger for Google AI Overviews than separate schemas
 */
export const GatePageSchema = ({ faqItems }) => {
  // FAQPage Entity linking to global SiteSchema entities
  const combinedSchema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "FAQPage",
        "@id": "https://xtreamgate.com/#faqpage",
        "name": "XtreamGate - Frequently Asked Questions",
        "url": "https://xtreamgate.com",
        "isPartOf": {
          "@id": "https://xtreamgate.com/#website"
        },
        "mainEntity": faqItems && faqItems.length > 0 ? faqItems.map(item => ({
          "@type": "Question",
          "name": item.question,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": item.answer
          }
        })) : []
      }
    ]
  };

  return (
    <Helmet>
      {/* Combined Schema Graph - Stronger for AIO indexing than separate schemas */}
      <script type="application/ld+json">
        {JSON.stringify(combinedSchema)}
      </script>
    </Helmet>
  );
};
